import { useDeviceSelectors } from "react-device-detect";
import { useMediaQuery } from "usehooks-ts";
export function useIsMobile() {
    const isMobile = useMediaQuery("(max-width: 767px)");
    const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1023px)");
    const [selectors] = useDeviceSelectors(typeof window !== "undefined" ? window.navigator.userAgent : "");
    return isMobile || isTablet || selectors.isMobile;
}
